import './portal.scss'

import React from 'react'
import ReactDOM from 'react-dom'

const loadingLanding = document.getElementById('loading')

export default class Portal extends React.Component<React.PropsWithChildren> {
  private el: HTMLElement

  constructor(props) {
    super(props)
    this.el = document.createElement('div')
  }

  componentDidMount() {
    // The portal element is inserted in the DOM tree after
    // the Modal's children are mounted, meaning that children
    // will be mounted on a detached DOM node. If a child
    // component requires to be attached to the DOM tree
    // immediately when mounted, for example to measure a
    // DOM node, or uses 'autoFocus' in a descendant, add
    // state to Modal and only render the children when Modal
    // is inserted in the DOM tree.
    if (loadingLanding) {
      loadingLanding.appendChild(this.el)
    }
  }

  componentWillUnmount() {
    if (loadingLanding) {
      loadingLanding.removeChild(this.el)
    }
  }

  render() {
    this.el.className = 'portal-overlay'
    return ReactDOM.createPortal(this.props.children, this.el)
  }
}
